<div class="error">
  @if (error) {
    <hyperkit-typography
      variant="emphasized"
      size="sm"
      color="error"
      >{{ error }}</hyperkit-typography
      >
    }
  </div>
